import React from 'react';
import PropTypes from 'prop-types';

import DialogModal from '../../../components/DialogModal';
import WorkoutEditor from '../../pages/WorkoutsManager/Workouts/WorkoutEditor';

import {
  Wrapper,
} from './styles';

const WorkoutEditorModal = ({
  showModal,
  workout,
  workoutAssignment,
  scheduledWorkoutDraft,
  editorAction,
  programDoc,
  dayIndex,
  programWorkoutDays,
  onSaveScheduledWorkoutDraft,
  onSave,
  onClose,
}) => (
  <DialogModal
    open={showModal}
    onClose={onClose}
    fullWidth
    maxWidth="xl"
  >
    <Wrapper>
      <WorkoutEditor
        workout={workout}
        workoutAssignment={workoutAssignment}
        scheduledWorkoutDraft={scheduledWorkoutDraft}
        programDoc={programDoc}
        dayIndex={dayIndex}
        programWorkoutDays={programWorkoutDays}
        onSaveScheduledWorkoutDraft={onSaveScheduledWorkoutDraft}
        onSave={onSave}
        onClose={onClose}
        action={editorAction}
      />
    </Wrapper>
  </DialogModal>
);

WorkoutEditorModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  workout: PropTypes.object,
  workoutAssignment: PropTypes.object,
  scheduledWorkoutDraft: PropTypes.object,
  editorAction: PropTypes.string.isRequired,
  programDoc: PropTypes.object,
  dayIndex: PropTypes.number,
  programWorkoutDays: PropTypes.array,
  onSaveScheduledWorkoutDraft: PropTypes.func,
  onSave: PropTypes.func,
  onClose: PropTypes.func,
};

WorkoutEditorModal.defaultProps = {
  workout: null,
  workoutAssignment: null,
  scheduledWorkoutDraft: null,
  programDoc: null,
  dayIndex: null,
  programWorkoutDays: [],
  onSaveScheduledWorkoutDraft: () => {},
  onSave: () => {},
  onClose: () => {},
};

export default WorkoutEditorModal;
